var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseErrorMsg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6787 10.7468C20.6787 5.30795 16.2661 0.895264 10.8272 0.895264C5.38827 0.895264 0.975586 5.30795 0.975586 10.7468C0.975586 16.1857 5.38827 20.5984 10.8272 20.5984C16.2661 20.5984 20.6787 16.1857 20.6787 10.7468Z",
    stroke: "#0073B5",
    strokeWidth: 0.985158,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1117 14.0308L7.54395 7.46304",
    stroke: "#0073B5",
    strokeWidth: 0.985158,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.54395 14.0308L14.1117 7.46304",
    stroke: "#0073B5",
    strokeWidth: 0.985158,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseErrorMsg);
export default __webpack_public_path__ + "static/media/close-error-msg.306e89d2490d8e512cda37b634185407.svg";
export { ForwardRef as ReactComponent };